import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import DashboardPage from '@/views/DashboardPage.vue';
import DeviceList from '@/views/DeviceList.vue';
import DeviceDetails from '@/views/DeviceDetails.vue';
import EventsPage from '@/views/EventsPage.vue';
import SettingsPage from '@/views/SettingsPage.vue';
import IntegrationGallery from '@/views/IntegrationGallery.vue';
import IntegrationList from '@/views/IntegrationList.vue';
import IntegrationEdit from '@/views/IntegrationEdit.vue';
import IntegrationAdd from '@/views/IntegrationAdd.vue';
import SecretList from '@/views/SecretList.vue';
import SecretDetails from '@/views/SecretDetails.vue';
import SecretAdd from '@/views/SecretAdd.vue';
import store from '@/store'
import FirmwareList from '@/views/FirmwareList.vue';
import FirmwareDetails from '@/views/FirmwareDetails.vue';
import ProjectsList from '@/views/ProjectsList.vue';
import ProjectsGallery from '@/views/ProjectsGallery.vue';
import ProjectEdit from '@/views/ProjectEdit.vue';
import ProjectAdd from '@/views/ProjectAdd.vue';

const routes = [
  { path: '', redirect: '/dashboard' },
  { path: '/dashboard',                  name: 'dashboard',           component: DashboardPage },
  { path: '/devices',                    name: 'device-list',         component: DeviceList },
  { path: '/devices/:id',                name: 'device-details',      component: DeviceDetails, props: true},
  { path: '/events',                     name: 'events',              component: EventsPage },
  { path: '/integrations',               name: 'integration-list',    component: IntegrationList },
  { path: '/integrations/add',           name: 'integration-gallery', component: IntegrationGallery },
  { path: '/integrations/:id',           name: 'integration-edit',    component: IntegrationEdit, props: true },
  { path: '/integrations/add/:template', name: 'integration-add',     component: IntegrationAdd, props: true },
  { path: '/secrets',                    name: 'secret-list',         component: SecretList },
  { path: '/secrets/add',                name: 'secret-add',          component: SecretAdd },
  { path: '/secrets/:name',              name: 'secret-details',      component: SecretDetails, props: true },
  { path: '/settings',                   name: 'settings',            component: SettingsPage, props: () => ({ user: store.state.user }) },
  { path: '/devices/firmwares',          name: 'firmware-list',       component: FirmwareList },
  { path: '/devices/firmwares/:sha',     name: 'firmware-details',    component: FirmwareDetails, props: true },
  { path: '/projects',                   name: 'project-list',        component: ProjectsList },
  { path: '/projects/add',               name: 'project-gallery',     component: ProjectsGallery },
  { path: '/projects/:id',               name: 'project-edit',        component: ProjectEdit, props: true },
  { path: '/projects/add/:template',     name: 'project-add',         component: ProjectAdd, props: true },
]

const router = createRouter({
  history: createWebHistory(),
  routes: routes as RouteRecordRaw[],
});

export default router;
